import React, {useEffect} from 'react';
import {ActionModal, ErrorModal, useErrorHandler} from '../../../../shared';
import {Text} from '@gravity-ui/uikit';
import {useClientVersionById} from '../../../../entities';

interface DeleteClientVersionModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  clientVersionId: string;
}

export const DeleteClientVersionModal = ({open, setOpen, clientVersionId}: DeleteClientVersionModalProps) => {
  const {deleteClientVersionMutation} = useClientVersionById();

  const {isErrorModalOpen, errorInfo, handleError, handleClose} = useErrorHandler({
    resourceName: 'Удаление версии приложения',
    title: 'Ошибка при удалении версии приложения',
  });

  useEffect(() => {
    if (deleteClientVersionMutation.error) {
      handleError(deleteClientVersionMutation.error as unknown as ApiError);
    }
  }, [deleteClientVersionMutation.error, handleError]);

  const handleSubmit = () => {
    deleteClientVersionMutation.mutate(clientVersionId, {
      onSuccess: () => {
        setOpen(false);
      },
    });
  };

  return (
    <>
      <ActionModal
        open={open}
        onClose={() => setOpen(false)}
        setOpen={() => setOpen(false)}
        submitForm={handleSubmit}
        isLoading={deleteClientVersionMutation.isPending}
        size={'s'}
        buttonsSize={'l'}
        caption={'Удаление версии приложения'}
        textButtonApply={'Удалить'}
        textButtonCancel={'Отменить'}
        viewActionButton="outlined-danger">
        <Text variant="body-2" color="secondary">
          Вы уверены, что хотите удалить эту версию приложения? Обратите внимание, что это действие безвозвратное
        </Text>
      </ActionModal>
      <ErrorModal open={isErrorModalOpen} onClose={handleClose} title={errorInfo.title} message={errorInfo.message} />
    </>
  );
};

